import styled from 'styled-components';

import { container } from 'styles/grid';

const Container = styled.div`
  ${container}
`;

export default Container;
